import axios from 'axios';
import { base_url } from './api-config'; 

const getHeaders = (operation: string, key_id?: number) => {
    let header: any = {
        "Content-Type": "application/json",
        "operation": operation
    }
    if (key_id && key_id != undefined && key_id != null) {
        header["key-id"] = key_id
    }

    return { 
        headers: header
    }
}

export const api_product = async (operation: string, body: any, key_id?: number) => {
    try {
        const res = await axios.post(`${base_url}/api/v1/product`, JSON.stringify(body || {}), getHeaders(operation, key_id));
        if (res && res.status === 200) {
            return res.data;
        }
        throw new Error(`Product API error (status ${res?.status})`);
    } catch (err) {
        console.error('api_product error:', err);
        throw err;
    }
}

export const api_product_lookup_code = async (product_code: string) => {
    try {
        const res = await api_product('GET_BY_CONDITION', { product_code: (product_code || '').trim() });
        if (res && res.id) {
            return res;
        }
        return null;
    } catch (err) {
        console.error('api_product_lookup_code error:', err);
        throw err;
    }
}

export const api_product_type = async (operation: string, body: any, key_id?: number) => {
    try {
        const res = await axios.post(`${base_url}/api/v1/product/type`, JSON.stringify(body), getHeaders(operation, key_id));
        if (res && res.status === 200) {
            return res.data;
        }
        throw new Error(`Product Type API error (status ${res?.status})`);
    } catch (err) {
        console.error('api_product_type error:', err);
        throw err;
    }
}

export const api_product_unit = async (operation: string, body: any, key_id?: number) => {
    try {
        const res = await axios.post(`${base_url}/api/v1/product/unit`, JSON.stringify(body), getHeaders(operation, key_id));
        if (res && res.status === 200) {
            return res.data;
        }
        throw new Error(`Product Unit API error (status ${res?.status})`);
    } catch (err) {
        console.error('api_product_unit error:', err);
        throw err;
    }
}

export const api_good_receive = async (operation: string, body: any, key_id?: number) => {
    try {
        const res = await axios.post(`${base_url}/api/v1/good/receive`, JSON.stringify(body || {}), getHeaders(operation, key_id));
        if (res && res.status === 200) {
            return res.data;
        }
        throw new Error(`Good Receive API error (status ${res?.status})`);
    } catch (err) {
        console.error('api_good_receive error:', err);
        throw err;
    }
}

export const api_check_stock = async (operation: string, body: any, key_id?: number) => {
    let result: any = [];

    await axios.post(`${base_url}/api/v1/check/stock`, JSON.stringify(body), getHeaders(operation, key_id))
        .then(res => {
            if (res && res.status == 200) {
                result = res.data;
            }
        }).catch(e => {
            // A DELETE must be able to fail out loud: the caller decides
            // what a 404 means and shows Backend's own reason. Swallowing
            // it returned `[]`, which every delete handler read as the
            // generic "ลบข้อมูลไม่สำเร็จ". LIST/GET keep the old contract --
            // `[]` on failure -- because screens render that as empty.
            if (operation === 'DELETE') throw e;
        })

    return result;
}

export const api_stock = async (operation: string, body: any, key_id?: number) => {
    let result: any = [];

    await axios.post(`${base_url}/api/v1/stock`, JSON.stringify(body), getHeaders(operation, key_id))
        .then(res => {
            if (res && res.status == 200) {
                result = res.data;
            }
        }).catch(e => {
            // A DELETE must be able to fail out loud: the caller decides
            // what a 404 means and shows Backend's own reason. Swallowing
            // it returned `[]`, which every delete handler read as the
            // generic "ลบข้อมูลไม่สำเร็จ". LIST/GET keep the old contract --
            // `[]` on failure -- because screens render that as empty.
            if (operation === 'DELETE') throw e;
        })

    return result;
}

export const api_withdraw = async (operation: string, body: any, key_id?: number) => {
    let result: any = [];

    await axios.post(`${base_url}/api/v1/withdraw`, JSON.stringify(body), getHeaders(operation, key_id))
        .then(res => {
            if (res && res.status == 200) {
                result = res.data;
            }
        }).catch(e => {
            // A DELETE must be able to fail out loud: the caller decides
            // what a 404 means and shows Backend's own reason. Swallowing
            // it returned `[]`, which every delete handler read as the
            // generic "ลบข้อมูลไม่สำเร็จ". LIST/GET keep the old contract --
            // `[]` on failure -- because screens render that as empty.
            if (operation === 'DELETE') throw e;
        })

    return result;
}

/*
 * A failed call is a failed call.
 *
 * This swallowed every error and returned an empty list, exactly like the
 * Consignment, Expense, Member, Vendor and Report clients did before the
 * Phase 7C-6C sweep. Two consequences, both real: `[]` is truthy, so
 * callers testing `if (res)` read a failure as a success; and Backend's
 * own reason -- "ไม่สามารถลบ... เนื่องจากมีรายการรับเข้าสินค้าที่ยืนยันแล้ว"
 * on a refused delete -- could never reach the user.
 *
 * Errors carrying a response pass through untouched, because callers read
 * `e.response.data.message` and the auth interceptor needs to see the
 * 401; only a failure with no response at all (offline, DNS, timeout)
 * arrives as a plain axios error.
 */
export const api_purchase_order = async (operation: string, body: any, key_id?: number) => {
    let result: any = [];

    const res = await axios.post(`${base_url}/api/v1/purchase/order`, JSON.stringify(body), getHeaders(operation, key_id));
    if (res && res.status === 200) {
        result = res.data;
    }

    return result;
}
